var _defs, _circle, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radarGradient",
    cx: "0%",
    cy: "50%",
    r: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2E8267",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2E8267",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "circleMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 180,
    fill: "white"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 180,
    fill: "none",
    stroke: "#2E8267",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2E8267",
    strokeWidth: 0.6,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 90
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 135
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2E8267",
    strokeWidth: 0.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 20,
    x2: 200,
    y2: 380
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 200,
    x2: 380,
    y2: 200
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#2E8267"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 150,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 270,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 245,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "2.4s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#circleMask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 200 L380 200 A180 180 0 0 1 200 380 Z",
    fill: "url(#radarGradient)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 200 200",
    to: "360 200 200",
    dur: "2.8s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.eb1655e725631eebb989317061f8c112.svg";
export { ForwardRef as ReactComponent };